document.querySelectorAll('.js-service-area-map').forEach((element) => {
  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;

    element.classList.add('service-area-map--visible');
    observer.disconnect();
  }, { threshold: 0.35 });

  observer.observe(element);
});
